<template>
    <div class="fill-height" style="width: 100%" :key="key">
        <!-- isAccountingUser: {{ isAccountingUser }} -->
        <ReconciliationFull2
            v-if="isAccountingUser"
            :companyId="companyId"
            :bankTransactionId="bankTransactionId"
            :documentId="documentId"
            :reconciliationId="reconciliationId"
            :accountingLineId="accountingLineId"
            :inbeddedMode="inbeddedMode"
            :mode="mode"
            :previousIdIsset="previousIdIsset"
            :nextIdIsset="nextIdIsset"
            @previous="previous"
            @next="next"
            @update="update"
        />
        <ReconciliationFullClient
            v-else
            :companyId="companyId"
            :bankTransactionId="bankTransactionId"
            :documentId="documentId"
            :reconciliationId="reconciliationId"
            :accountingLineId="accountingLineId"
            :mode="mode"
            :editable="isEditable"
            :previousIdIsset="previousIdIsset"
            :nextIdIsset="nextIdIsset"
            @previous="previous"
            @next="next"
            @update="update"
        />
    </div>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";
import { User } from "../store/store";

import ReconciliationFull2 from "./ReconciliationFull2.vue";
import ReconciliationFullClient from "./ReconciliationFullClient.vue";
import { Component, Vue, toNative, Prop, Provide} from "vue-facing-decorator";

@Component({
    name: "Reconciliation",
    components: {
        ReconciliationFull2,
        ReconciliationFullClient,
    },
    emits: ["previous", "next", "update"],
})
export class Reconciliation extends Vue {
    @Prop({ default: false }) inbeddedMode: boolean;
    @Prop({ default: "Router" }) mode: string;

    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) bankTransactionId: string;
    @Prop({ default: "" }) documentId: string;
    @Prop({ default: "" }) reconciliationId: string;
    @Prop({ default: "" }) accountingLineId: string;

    @Prop({ default: false }) nextIdIsset: boolean;
    @Prop({ default: false }) previousIdIsset: boolean;

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get internaCompanyId() {
        if (this.companyId) {
            return this.companyId;
        }
        if (this.bankTransaction?.account?.company) {
            return this.bankTransaction.account.company.id;
        }
        return "";
    }

    get selectedCompany() {
        if (this.internaCompanyId) {
            return this.$store.getters.getCompany(this.internaCompanyId);
        }
        return null;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    previous() {
        this.$emit("previous");
    }

    next() {
        this.$emit("next");
    }

    update() {
        this.$emit("update");
    }

    get key() {
        return (
            this.bankTransactionId ||
            this.documentId ||
            this.reconciliationId ||
            this.accountingLineId
        );
    }

    @Apollo({
        query: gql`
            query BankTransaction($id: ID!) {
                bankTransaction(where: { id: $id }) {
                    id
                    status
                    account {
                        id
                        company {
                            id
                        }
                    }
                    reconciliation {
                        documents {
                            original{
                                id
                            }
                        }
                    }
                }
            }
        `,
        variables() {
            return {
                id: this.bankTransactionId,
            };
        },
        skip() {
            return !this.bankTransactionId;
        },
        specificResult({ data, loading }) {
            if (!loading) {
                if (data && data.bankTransaction) {
                    this.bankTransaction = data.bankTransaction;
                } else {
                    this.bankTransaction = null;
                }
            }
        },
    })
    bankTransaction;

    @Provide('initialHasReconciliationDocuments')
    get provideInitialHasReconciliationDocuments() {
        return this.bankTransaction?.reconciliation?.documents?.filter(
            (doc) => typeof doc.original !== "undefined"
        ).length > 0;
    }

    get bankTransactionStatus() {
        if (this.bankTransaction) {
            return this.bankTransaction.status;
        }
        return "";
    }

    get reconciliationFullManagement() {
        // if (this.$vuetify.display.mobile) {
        //     return false
        // }
        if (this.isAccountingUser) {
            return false;
        }
        if (this.documentId) {
            return true;
        }
        if (!this.bankTransactionStatus) {
            return false;
        }
        return true;
    }

    get isEditable() {
        if (!this.selectedCompany) {
            return false;
        }
        if (this.selectedCompany.solution === "MANAGEMENT") {
            return true;
        }
        if (!this.bankTransactionId) {
            return false;
        }
        if (this.selectedCompany?.profile?.accountingType === "INCOMING_OUTGOING_PAYMENT") {
            return true;
        }
        return this.bankTransactionStatus === "INFORMATION_REQUEST";
    }
}

export default toNative(Reconciliation);
</script>
